class SignInController {
  /* @ngInject */
  constructor(
    $window, $state, $location, $rootScope, Auth, AUTH_EVENTS, Session, urls, $http, $stateParams
  ) {
    this.$window = $window;
    this.$state = $state;
    this.$location = $location;
    this.$rootScope = $rootScope;
    this.$http = $http;
    this.Auth = Auth;
    this.urls = urls;
    this.AUTH_EVENTS = AUTH_EVENTS;
    this.Session = Session;
    this.$stateParams = $stateParams;
  }

  $onInit() {
    const user = this.Session.read('userinfo');
    this.updatePageTags();
    this.setUtm();
    if (user) {
      this.user = this.Session.read('userinfo');
      if (this.$state.params.client_id) {
        this.$window.localStorage.client_id = this.$state.params.client_id;
      }
      return this.clientRedirect();
    }

    this.objects = [
      {
        object: 'https://mcusercontent.com/8f7212d51aa9533c4788ccf05/images/87212205-9631-85c5-e510-8f2dc8c3fe75.jpg',
        link: 'https://www.shoppre.com/personal-shopper-offers'
      },
      {
        object: 'https://mcusercontent.com/8f7212d51aa9533c4788ccf05/images/05f17920-8548-bad6-6e76-67c366747e84.jpg',
        link: 'https://www.shoppre.com/first-time-international-shipment-offer'
      },
      {
        object: 'https://mcusercontent.com/8f7212d51aa9533c4788ccf05/images/5710996f-4973-4170-8f22-7034780a8eda.png',
        link: 'https://www.shoppre.com/indian-virtual-address'
      },
      {
        object: 'https://mcusercontent.com/8f7212d51aa9533c4788ccf05/images/2e9b692f-9152-4bd1-babb-37db778234d4.png',
        link: 'https://www.shoppre.com/indian-virtual-address'
      },
    ];

    if (this.$state.params.state) {
      const stateData = JSON.parse(atob(this.$state.params.state));
      if (stateData.client_id && stateData.client_id != undefined && stateData.client_id != 'undefined' ) {
        this.$state.params.client_id = stateData.client_id;
        this.$window.localStorage.client_id = this.$state.params.client_id;
        this.$location.search().client_id = stateData.client_id;
      }
      this.$location.search().continue = stateData.continue;
      this.$state.params.continue = stateData.continue;
    }
    this.message = this.$state.params.message;

    if (this.$state.params.type) {
      this.$state.params.client_id = this.$state.params.client_id || this.$location.search().client_id;
    }

    if (this.$state.params.type) {
      this.$state.params.client_id = this.$state.params.client_id || this.$location.search().client_id;
    }

    this.error = null;
    this.user = {
      username: this.$state.params.username || '',
      password: this.$state.params.password || '',
    };

    this.app = this.$state.params.app;
    if (this.app) this.Session.create('app', this.app);

    if (this.$state.params.code
      || (this.$state.params.username && this.$state.params.password)) {
      return this.signin(this.$state.params.code, this.$state.params.type, this.$state.params.client_id);
    }
    this.is_email_verified = true;
    this.show = true;
    return null;
  }

  updatePageTags() {
    var link = document.createElement('meta');
    link.setAttribute('name', 'description');
    link.content = 'Hey welcome back! Log in to your ShoppRe account to access your package details, status, wallet balance, and secure online payment and shipping services';
    this.$window.document.getElementsByTagName('head')[0].appendChild(link);

    var link = !!document.querySelector("link[rel='canonical']") ? document.querySelector("link[rel='canonical']") : document.createElement('link');
    link.setAttribute('rel', 'canonical');
    link.setAttribute('href', location.protocol + '//' + location.host + location.pathname);
    this.$window.document.head.appendChild(link);

    var link = document.createElement('meta');
    link.setAttribute('name', 'robot');
    link.content = 'noindex';
    this.$window.document.getElementsByTagName('head')[0].appendChild(link);
  }

  getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop()
      .split(';')
      .shift();
  }

  setUtm() {
    if (this.$state.params.utm_source && this.$state.params.utm_source != 'undefined') {
      document.cookie = `utm_source=${this.$state.params.utm_source};domain=${this.urls.DOMAIN};`;
    }

    if (this.$state.params.utm_campaign && this.$state.params.utm_campaign != 'undefined') {
      document.cookie = `utm_campaign=${this.$state.params.utm_campaign};domain=${this.urls.DOMAIN};`;
    }

    if (this.$state.params.utm_medium && this.$state.params.utm_medium != 'undefined') {
      document.cookie = `utm_medium=${this.$state.params.utm_medium};domain=${this.urls.DOMAIN};`;
    }
    if (this.$state.params.original_source && this.$state.params.original_source != 'undefined') {
      document.cookie = `original_source=${this.$state.params.original_source};domain=${this.urls.DOMAIN};`;
    }
    if (this.$state.params.parameter_url && this.$state.params.parameter_url != 'undefined') {
      document.cookie = `parameter_url=${this.$state.params.parameter_url};domain=${this.urls.DOMAIN};`;
    }
    if (this.$state.params.gcl_id && this.$state.params.gcl_id != 'undefined') {
      document.cookie = `gcl_id=${this.$state.params.gcl_id};domain=${this.urls.DOMAIN};`;
    }

    if (this.$state.params.referrer && this.$state.params.referrer != 'undefined') {
      document.cookie = `referrer=${this.$state.params.referrer};domain=${this.urls.DOMAIN};`;
    }
    if (this.$state.params.first_visit && this.$state.params.first_visit != 'undefined') {
      document.cookie = `first_visit=${this.$state.params.first_visit};domain=${this.urls.DOMAIN};`;
    }

    if (this.$state.params.post_login_page && this.$state.params.post_login_page != 'undefined') {
      this.$stateParams.continue = this.$state.params.post_login_page;
      document.cookie = `post_login_page=${this.$state.params.post_login_page};domain=${this.urls.DOMAIN};`;
    }

    if (this.$state.params.collect_coupon && this.$state.params.collect_coupon != 'undefined') {
      document.cookie = `collect_coupon=${this.$state.params.collect_coupon};domain=${this.urls.DOMAIN};`;
    }
    const fromDomain = this.getCookie('from_domain');

    if (this.$state.params.from_domain && this.$state.params.from_domain != 'undefined' && fromDomain != '') {
      document.cookie = `from_domain=${this.$state.params.from_domain};domain=${this.urls.DOMAIN};`;
    } else {
      document.cookie = `from_domain=${this.urls.DOMAIN};domain=${this.urls.DOMAIN};`;
    }
  }


  signin(code, type, clientId) {
    this.error = null;
    this.show = false;

    const { username, password } = this.user;

    const utmSource = this.getCookie('utm_source');
    const utmMedium = this.getCookie('utm_medium');
    const utmCampaign = this.getCookie('utm_campaign');
    const originalSource = this.getCookie('original_source');
    const parameterUrl = this.getCookie('parameter_url');
    const gclId = this.getCookie('gcl_id');
    const fromDomain = this.getCookie('from_domain');
    const referrer = this.getCookie('referrer');
    const firstVisit = this.getCookie('first_visit');
    const collectCoupon = this.getCookie('collect_coupon');
    const referralCode = this.getCookie('referral_code');

    let options = {};
    if (utmSource) {
      options = {
        username,
        password,
        utm_source: utmSource,
        utm_medium: utmMedium,
        utm_campaign: utmCampaign,
        original_source: originalSource,
        parameter_url: parameterUrl,
        gcl_id: gclId,
        from_domain: fromDomain,
        referrer: referrer,
        first_visit: firstVisit,
        collect_coupon: collectCoupon,
        referral_code: referralCode,
      };
    } else {
      options = {
        username,
        password,
        collect_coupon: collectCoupon,
      };
    }
    // Try to login
    this.Auth
      .login(code ? {
        grant_type: type, code, client_id: clientId,
        utm_medium: utmMedium, utm_source: utmSource, utm_campaign: utmCampaign,
        original_source: originalSource, parameter_url: parameterUrl, gcl_id: gclId,
        from_domain: fromDomain, first_visit: firstVisit, referrer, collect_coupon: collectCoupon,
        referral_code: referralCode,
      } : options)
      .then(() => {
        this.$rootScope.$broadcast(this.AUTH_EVENTS.loginSuccess);
        this.Auth
          .setSessionData()
          .then(() => {
            const { $location, $state } = this;
            const { whatBlocked = [] } = this.Session.read('userinfo') || {};
            const [state] = whatBlocked.map((x) => x.state);
            if (state === 'password-change') return $state.go(state);

            const stateOptions = {};
            if (![undefined, 'undefined', null].includes(this.$location.search().client_id)) {
              stateOptions.client_id = this.$location.search().client_id;
            }
            let continueUrl = this.getCookie('post_login_page');
            if (continueUrl) {
              this.$location.search().continue = continueUrl;
              stateOptions.continue = continueUrl;
            } else if ($location.search().continue) {
              if (this.$location.search().continue !== '/signup' && this.$location.search().continue !== '/signin') {
                stateOptions.continue = this.$location.search().continue;
              }
            }
            if (!stateOptions.client_id && $location.search().client_id) {
              stateOptions.client_id = this.$location.search().client_id;
            }

            const user = this.Session.read('userinfo');
            const that = this;
            if (user) {
              if (!user.is_email_verified && user.email.includes('@shoppre.com')) {
                this.message = 'Verify your account to login';
                this.$window.localStorage.clear();
                this.loading = true;
                this.show = true;
                return null;
              }
              const { LOGIN_APP } = this.urls;
              const url = `${LOGIN_APP}/api/users/${user.id}`;

              this.$http.get(url)
                .then(({ data }) => {
                  const userCreated = new Date(data.created_at).toISOString()
                    .slice(0, 10);
                  const checkDate = new Date(data.emailVerificationStartDate).toISOString()
                    .slice(0, 10);
                  // const afterSevenDays = new Date(userCreated).setDate(new Date(userCreated).getDate() + 7);
                  var today = new Date().toISOString()
                    .slice(0, 10);
                  var afterSevenDays = new Date(userCreated);
                  afterSevenDays.setDate(afterSevenDays.getDate() + 7);
                  afterSevenDays = new Date(afterSevenDays).toISOString()
                    .slice(0, 10);
                  if (data.is_disabled === 1) {
                    that.show = true;
                    this.Session.remove('userinfo');
                    return this.message = 'User is disabled, Please ask customer support to re enable your account';
                  }
                  if (!data.is_email_verified && userCreated >= checkDate
                    && today >= afterSevenDays) {
                    that.is_email_verified = false;
                    that.show = true;
                    this.Session.remove('userinfo');
                    return this.message = 'Please verify your Email id';
                  } else {
                    return this.clientRedirect();
                  }
                });
            } else {
              return this.clientRedirect();
            }
          });
      }, ({ data }) => {
        this.show = true;
        this.$rootScope.$broadcast(this.AUTH_EVENTS.loginFailed);
        this.error = data.error_description;
      });
  }

  clientRedirect() {
    let { client_id: clientId } = this.$stateParams;
    const clientIdLocalStorage = this.$window.localStorage.client_id;
    if (clientIdLocalStorage) {
      return this.redirect(clientIdLocalStorage);
    }
    const user = this.Session.read('userinfo');
    debugger;

    const clientIdLS = (clientIdLocalStorage || '').toString().toUpperCase();
    const clientIdVal = (clientId || '').toString().toUpperCase();
    if (
      !user.email.includes('@shoppre.com') &&
      (clientIdLS === 'PSOMS' || clientIdVal === 'PSOMS')
    ) {
      this.Session.remove('userinfo');
      this.Session.remove('oauth');
      this.show = true;
      return this.message = 'User Credentials invalid';
    }


    if ([undefined, 'undefined', null].includes(clientId)) {
      if (user.email.includes('@shoppre.com')) {
        clientId = 'parcel-admin';
      } else if (user.suite_number) {
        clientId = 'sns';
      } else {
        clientId = 'parcel';
      }
    }
    if (!clientId) {
      this.getApps();
    }

    return this.redirect(clientId);
  }

  redirect(clientId) {
    const user = this.Session.read('userinfo');
    const { location } = this.$window;
    const { PREFIX, LOGIN_PARCELS_DOMAIN } = this.urls;
    if (user && !user.email.includes(this.urls.GSUITE_DOMAIN)) {
      this.utmHistory().then(() => {
        this.collectCoupon().then(() => {
          this.referralCredit().then(() => {
            return (location.href = this
            .href(clientId, `${PREFIX}${clientId.replace('-admin', '')}.${LOGIN_PARCELS_DOMAIN}`));
          });
        });
      });
    } else {
      return (location.href = this
        .href(clientId, `${PREFIX}${clientId.replace('-admin', '')}.${LOGIN_PARCELS_DOMAIN}`));
    }
  }

  collectCoupon() {
    try {
      const user = this.Session.read('userinfo');
      const collectCoupon = this.getCookie('collect_coupon');

      if (collectCoupon && collectCoupon !== 'undefined') {
        const options = {
          user_id: user.id,
          coupon_code: collectCoupon,
          is_availed: false,
        };

        // Return the Promise from $http.post
        return this.$http.post(`${this.urls.CAMPAIGN}/api/usercoupons`, options)
          .then(() => {
            // Return the Promise from document.cookie assignment
            return new Promise((resolve) => {
              document.cookie = 'collect_coupon' + `=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;Domain=.${document.domain.split('.')
                .splice(1)
                .join('.')}`;
              resolve();
            });
          })
          .catch((error) => {
            console.error(error);
            // Return a rejected Promise
            return Promise.reject(error);
          });
      } else {
        // Return a resolved Promise with a value of 0
        return Promise.resolve(0);
      }
    } catch (error) {
      console.error(error);
      // Return a rejected Promise
      return Promise.reject(error);
    }
  }

  referralCredit() {
    // Return the promise chain
    return this.$http.get('/users/me')
      .then(({ data: me }) => {
        if (!me.is_referral_amount_credit && me.referral_code) {
          // Return the promise from the $http.post call
          return this.$http.post(`/users/${me.id}/referralCredit`)
            .then(() => {
              // Optionally, you can return some value if needed
              return 'Referral credit applied successfully';
            })
            .catch((error) => {
              // Handle error for $http.post
              console.error('Error applying referral credit:', error);
              // Propagate the error
              throw error;
            });
        }
      })
      .catch((error) => {
        // Handle error for $http.get
        console.error('Error fetching user data:', error);
        // Propagate the error
        throw error;
      });
  }
  utmHistory() {
    const utmSource = this.getCookie('utm_source');
    const utmMedium = this.getCookie('utm_medium');
    const utmCampaign = this.getCookie('utm_campaign');
    const originalSource = this.getCookie('original_source');
    const parameterUrl = this.getCookie('parameter_url');
    const gclId = this.getCookie('gcl_id');
    const fromDomain = this.getCookie('from_domain');
    const referrer = this.getCookie('referrer');
    const firstVisit = this.getCookie('first_visit');
    const collectCoupon = this.getCookie('collect_coupon');

    const options = {
      utm_source: utmSource,
      utm_medium: utmMedium,
      utm_campaign: utmCampaign,
      original_source: originalSource,
      parameter_url: parameterUrl,
      gcl_id: gclId,
      from_domain: fromDomain,
      referrer: referrer,
      first_visit: firstVisit,
      collect_coupon: collectCoupon,
    };
    const { LOGIN_APP } = this.urls;
    const url = `${LOGIN_APP}/api/utmhistory`;
    return this.$http.post(url, options);
  }


  href(_clientId, baseUrl) {
    const user = this.Session.read('userinfo');
    const project = _clientId.replace('-admin', '');
    const clientId = ((user.email.includes(this.urls.GSUITE_DOMAIN) || user.group_id === 1) && (project !== 'psoms'))
      ? `${project}-admin`
      : project;
    const suffix = `${clientId.includes('-admin', '') ? 'admin/' : ''}access/oauth`;
    this.$window.localStorage.client_id = clientId;

    if (this.Session.read('member')) {
      const member = this.Session.read('member');
      if (this.Session.read('member')) {
        this.Session.remove('member');
      }
      const params = {
        client_id: clientId,
        continue: this.$stateParams.continue,
        response_type: 'code',
        redirect_uri: `${baseUrl}/${clientId === 'accounts' ? 'signin' : suffix}`,
      };

      return this.authorise(params)
        .then(x => {
          console.log(x);
        });
    } else {
      const continueUrl = this.$stateParams.continue ? this.$stateParams.continue.replace('&', '%26') : null;
      const params = {
        client_id: clientId,
        continue: continueUrl,
        response_type: 'code',
        redirect_uri: `${baseUrl}/${clientId === 'accounts' ? 'signin' : suffix}`,
      };
      return this.authorise(params)
        .then(x => {
          console.log(x);
        });
    }
  }

  getApps() {
    return this.$http
      .get('/apps?domain_id=1')
      .then(({ data }) => {
        const fromDomain = this.getCookie('from_domain');
        this.clearCookie();
        this.APPS = data;
        if (fromDomain === 'shoppre.com' || fromDomain === 'shoppre.test') {
          this.redirect('parcel');
        }
        this.clearCookie();
      });
  }

  clearCookie() {
    const cookieList = ['utm_source', 'utm_medium', 'gcl_id', 'from_domain', 'post_login_page',
      'utm_campaign', 'original_source', 'parameter_url', 'referrer', 'first_visit', 'collect_coupon'];
    cookieList.map(x => {
      document.cookie = x + `=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;Domain=.${document.domain.split('.')
        .splice(1)
        .join('.')}`;
    });
  }

  socialRedirect(type) {
    const { LOGIN_APP } = this.urls;
    const query = this.$location.search();
    let url = `${LOGIN_APP}/api/oauth`;

    let continueUrl = '';
    if (this.$location.search().continue) {
      if (this.$location.search().continue !== '/signup' && this.$location.search().continue !== '/signin') {
        continueUrl = this.$location.search().continue;
      }
    }

    if (type === 'google') {
      url += `/google?continue=${continueUrl}&client_id=${query.client_id}`;
    } else {
      url += `/facebook?continue=${continueUrl}&client_id=${query.client_id}`;
    }
    // this.$window.location.href = url;
    this.$http.get(url)
      .then(({ data }) => {
        this.$window.location.href = data.redirectUrl;
      });
  }

  resendEmail() {
    this.user = this.Session.read('userinfo');
    const url = `${this.URLS.LOGIN}/api/users/sendVerify/email`;
    this.$http
      .get(url, { params: this.user })
      .then(() => {
        this
          .toaster
          .pop('success', 'Verification Email Send', '');
      })
      .catch((err) => {
        this
          .toaster
          .pop('error',
            'There was problem For Verification Email Send. Please contact Shoppre team.');

        this.error = err.data;

        return false;
      });
  }

  authorise(params) {
    const { location } = this.$window;
    const url = `${this
      .urls.LOGIN_APP}/api/authorise`;
    let continueUrl = '';
    this
      .$http
      .post(url, Object.assign(params, { allow: 'true' }), { params })
      .then(({ data }) => {
        if (params.membership_type) {
          location.href = `${data}&membershipType=${params.membership_type}&membershipAmount=${params.membership_amount}`;
        } else {
          if (params.continue) {
            if (params.continue.includes('https')) {
              continueUrl = `&continue=${params.continue}`;
            } else if (!params.continue.includes('authorise')) {
              continueUrl = `&state=${params.continue}`;
            }
          }

          if (this.Session.read('app')) {
            const app = this.Session.read('app');
            continueUrl = `&app=${app}`;
            this.Session.remove('app');
          }

          location.href = `${data}${continueUrl}`;
        }
        return null;
      })
      .catch((err) => {
        const { data } = err;
        return (this.error = (data && data.error));
      });
  }
}

export default SignInController;



// WEBPACK FOOTER //
// ./client/app/oauth/sign-in/sign-in.controller.js